import { getJson } from "./apiClient";
import { normalizeCategory } from "../models/category.model";

/**
 * @param {{ lang?: string, onlyActive?: boolean }} [opts]
 */
export async function fetchCategories(opts = {}) {
  const { lang = "ar", onlyActive = true } = opts;

  // Endpoint: /api/Categories?lang=ar
  const data = await getJson("/api/Categories", { lang });

  const list = Array.isArray(data) ? data.map(normalizeCategory) : [];

  // فلترة الفعال فقط (اختياري)
  const filtered = onlyActive ? list.filter((c) => c.isActive) : list;

  // ترتيب حسب displayOrder ثم الاسم
  filtered.sort((a, b) => (a.displayOrder - b.displayOrder) || a.name.localeCompare(b.name, "ar"));

  return filtered;
}
